import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { DashLayout } from "@/components/app/DashLayout";
import BuyerDashboard from "@/pages/buyer/BuyerDashboard";
import NewRequest from "@/pages/buyer/NewRequest";
import MyRequests from "@/pages/buyer/MyRequests";
import RequestDetail from "@/pages/buyer/RequestDetail";
import Orders from "@/pages/buyer/Orders";
import SupplierDashboard from "@/pages/supplier/SupplierDashboard";
import SupplierRFQs from "@/pages/supplier/SupplierRFQs";
import SupplierProfile from "@/pages/supplier/SupplierProfile";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--navy))] text-slate-300">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin") return <Navigate to={`/${user.role}`} replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route element={<Protected roles={["buyer"]}><DashLayout /></Protected>}>
            <Route path="/buyer" element={<BuyerDashboard />} />
            <Route path="/buyer/new" element={<NewRequest />} />
            <Route path="/buyer/requests" element={<MyRequests />} />
            <Route path="/buyer/requests/:id" element={<RequestDetail />} />
            <Route path="/buyer/orders" element={<Orders />} />
          </Route>

          <Route element={<Protected roles={["supplier"]}><DashLayout /></Protected>}>
            <Route path="/supplier" element={<SupplierDashboard />} />
            <Route path="/supplier/rfqs" element={<SupplierRFQs />} />
            <Route path="/supplier/profile" element={<SupplierProfile />} />
          </Route>

          <Route element={<Protected roles={["admin"]}><DashLayout /></Protected>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/suppliers" element={<AdminSuppliers />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
